export const VALIDATE_MOBILE_SINGLE = 'VALIDATE_MOBILE_SINGLE';
export const VALIDATE_MOBILE_SINGLE_SUCCESS = 'VALIDATE_MOBILE_SINGLE_SUCCESS';
export const VALIDATE_MOBILE_SINGLE_FAIL = 'VALIDATE_MOBILE_SINGLE_FAIL';

export const VALIDATE_MOBILE_BULK = 'VALIDATE_MOBILE_BULK';
export const VALIDATE_MOBILE_BULK_SUCCESS = 'VALIDATE_MOBILE_BULK_SUCCESS';
export const VALIDATE_MOBILE_BULK_FAIL = 'VALIDATE_MOBILE_BULK_FAIL';
export const VALIDATE_MOBILE_BULK_RESET = 'VALIDATE_MOBILE_BULK_RESET';

export const GET_PROCESSED_FILES = 'GET_PROCESSED_FILES';
export const GET_PROCESSED_FILES_SUCCESS = 'GET_PROCESSED_FILES_SUCCESS';
export const GET_PROCESSED_FILES_FAIL = 'GET_PROCESSED_FILES_FAIL';

export const DOWNLOAD_PROCESSED_FILES = 'DOWNLOAD_PROCESSED_FILES';
export const DOWNLOAD_PROCESSED_FILES_SUCCESS = 'DOWNLOAD_PROCESSED_FILES_SUCCESS';
export const DOWNLOAD_PROCESSED_FILES_FAIL = 'DOWNLOAD_PROCESSED_FILES_FAIL';
